/** @format */
import {IconFillProps} from './model';

const IconStubs = ({fill}: IconFillProps) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M6 1.5C6 1.22386 6.22386 1 6.5 1H9.5C9.77614 1 10 1.22386 10 1.5C10 1.77614 9.77614 2 9.5 2H9V5.26L12.553 11.382C13.1732 12.4505 12.3952 13.8 11.1608 13.8H4.83921C3.60476 13.8 2.82681 12.4505 3.44701 11.382L7 5.26V2H6.5C6.22386 2 6 1.77614 6 1.5ZM8 5.54L4.30701 11.882C4.10694 12.2272 4.35292 12.66 4.75 12.66H11.25C11.6471 12.66 11.8931 12.2272 11.693 11.882L8 5.54Z'
      fill={fill}
    />
  </svg>
);

export default IconStubs;
